// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import axios from 'axios'
import store from './store'//引入store
import animated from 'animate.css'
// import VueWechatTitle from 'vue-wechat-title'
import vueTouch from 'kim-vue-touch'

Vue.use(vueTouch)
// import 'vueg/css/transition-min.css' // npm install animate.css --save安装，在引入
// Vue.use(animated)
// import 'vueg/css/transition-min.css'
// Vue.use(VueWechatTitle)
Vue.use(animated)
// Vue.config.productionTip = false

// Vue.prototype.$axios = axios
// axios.defaults.baseURL = '/api'  //关键代码

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js